import React from "react";
import "../../stylesheet/components/collapse/Collapse.scss";
import { Tag } from "../../compilers/tag";
import { LearningPathway } from "../../compilers/learningPathway";

type CollapseItemProps = {
  title: string;
  handleClick: (tag: Tag | LearningPathway) => void;
  dataObject: Tag | LearningPathway;
  isActive?: boolean;
};

const CollapseItem: React.FC<CollapseItemProps> = ({
  title,
  handleClick,
  dataObject,
  isActive = false,
}) => {
  const handleOnClick = () => {
    handleClick(dataObject);
  };

  return (
    <div className="collapse-item" onClick={handleOnClick}>
      {isActive ? <div className="circle-selected-cursor" /> : null}
      {isActive ? (
        <p className="p2" style={{ fontWeight: "600" }}>
          {title}{" "}
        </p>
      ) : (
        <p className="p2"> {title} </p>
      )}
    </div>
  );
};

export default CollapseItem;
